const innerHeightThreshold = 820 //max height of .inner element

const checkForGaps = (inner, nextInner) => {

    // if (nextInner.children.length && ( (sumChildrenHeights(inner) + nextInner.children[0].offsetHeight) <= innerHeightThreshold ) ){
    if (nextInner.children.length && ( (inner.scrollHeight + nextInner.children[0].offsetHeight) <= innerHeightThreshold ) ){

      return true //there's a gap to fill
    }
    else {
        return false //there's no gap to fill
    }
}

const sumChildrenHeights = (inner) => {
    if (!(inner instanceof Element)) {
        console.error('Invalid parent element.');
        return 0;
    }

    let totalHeight = 0;
    const children = inner.children;
    [...children].forEach(child => {
        const height = child.offsetHeight; // height of the child element
        totalHeight += height;
    })

    return totalHeight;
};

const checkOverflow = (element) => {
    if (!(element instanceof Element)) {
        console.error('Invalid element.');
        return false;
    }
    if (element.scrollHeight > innerHeightThreshold) {
        return true
    }
    else {
        return false
    }
};

const shiftForward = (innerElem) => {
    let inners = document.getElementsByClassName("dynamicContent");
    let nextInner = inners[[...inners].indexOf(innerElem) + 1] || null;
    if (nextInner && checkOverflow(innerElem)) {

      let nextInnerWrapper = nextInner.parentElement

      while (checkOverflow(innerElem)) {
        let child = innerElem.lastChild;
        nextInner.insertBefore(child, nextInner.firstChild);
        if(nextInner.children.length > 0) {
          nextInnerWrapper.parentElement.classList.remove("page-hidden")
        }
        else {
          nextInnerWrapper.parentElement.classList.add("page-hidden")
        }
      }
    }
}
const shiftBackward = (innerElem, index) => {
    let inners = document.getElementsByClassName("dynamicContent");

    let nextInner = inners[[...inners].indexOf(innerElem) + 1] || null;

    if (nextInner && checkForGaps(innerElem, nextInner)) {

      let nextInnerWrapper = nextInner.parentElement

      while (checkForGaps(innerElem, nextInner)) {
        let child = nextInner.removeChild(nextInner.children[0]);
        innerElem.appendChild(child);
        if(nextInner.children.length > 0) {
          nextInnerWrapper.parentElement.classList.remove("page-hidden")
        }
        else {
          nextInnerWrapper.parentElement.classList.add("page-hidden")
        }
      }
    }
}

const observer = new MutationObserver((mutationsList) => {
    for (const [index, mutation] of mutationsList.entries()) {
      if (mutation.target.parentElement && mutation.type === "characterData") {
        adjustContent();
      }
    }
  });

  const adjustContent = () => {
    [...document.getElementsByClassName("dynamicContent")].forEach((innerElem) => {
      if (checkOverflow(innerElem)) {
        //move last child to next inner
        shiftForward(innerElem)
      } else {
        //try to move first child of next .inner back
        shiftBackward(innerElem)
      }
    });
  }
export {checkForGaps, checkOverflow, observer, adjustContent}